import * as React from 'react';
import FeedbackWidget from '../../components/FeedbackWidget/FeedbackWidget';
import { FeedbackValue, IInternalFeedbackResult } from '../types';
import ComprehensionFeedbackSurvey from './ComprehensionFeedbackSurvey';
import NegativeFeedbackSurvey from './NegativeFeedbackSurvey';
import './WorkoutSurvey.scss';

export interface IWorkoutSurveyProps {
  onCompleteSurvey: (result: IInternalFeedbackResult) => void;
}

export const initialFeedback: IInternalFeedbackResult = {
  feedback: null,
  negativeFollowup: null,
  comprehensionFollowup: null,
};

const WorkoutSurvey: React.FC<IWorkoutSurveyProps> = ({ onCompleteSurvey }) => {
  const [result, setResult] = React.useState<IInternalFeedbackResult>(initialFeedback);
  const [comprehension, setComprehension] = React.useState<boolean>(false);
  const onFeedback = (feedback: FeedbackValue) => {
    const surveyResult = {
      ...result,
      feedback,
    };
    setResult(surveyResult);
    if (feedback === 1) {
      // for positive answers send feedback immediately
      onCompleteSurvey(surveyResult);
    }
  };

  const setNegativeFeedback = (negativeFollowup: FeedbackValue) => {
    const surveyResult = {
      ...result,
      negativeFollowup,
    };
    setResult(surveyResult);
    if (negativeFollowup === 1) {
      setComprehension(true);
      return;
    }
    // for non-comprehension negative answers send feedback immediately
    onCompleteSurvey(surveyResult);
  };

  const setComprehensionFeedback = (comprehensionFollowup: FeedbackValue) => {
    const surveyResult = {
      ...result,
      comprehensionFollowup,
    };
    setResult(surveyResult);
    onCompleteSurvey(surveyResult);
  };

  if (comprehension) {
    return <ComprehensionFeedbackSurvey onAnswer={setComprehensionFeedback} />;
  }
  if (result.feedback === 0) {
    return <NegativeFeedbackSurvey onAnswer={setNegativeFeedback} />;
  }
  return <FeedbackWidget onFeedback={onFeedback} />;
};

export default WorkoutSurvey;
